import { CommonModule } from "@angular/common";
import { Component, Inject } from "@angular/core";
import { FormGroup, ReactiveFormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from "@angular/material/dialog";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { TranslocoModule } from "@ngneat/transloco";
import { FormService } from "app/modules/admin/campaign/details/form.service";
import { DuplicateCampaignComponent } from "app/modules/admin/campaign/details/tabs/duplicate-campaign/duplicate-campaign.component";
import { FormFieldOption } from "app/shared/components/form-fields/base-input/base-input.component";
import { FormSectionComponent } from "app/shared/components/form-section/form-section.component";
import { Subject } from "rxjs";

@Component({
    selector: "as-soon-as",
    standalone: true,
    imports: [
        CommonModule,
        ReactiveFormsModule,
        FormSectionComponent,
        TranslocoModule,
        MatIconModule,
        MatButtonModule,
        MatDialogModule,
        MatFormFieldModule,
        MatInputModule,
    ],
    templateUrl: "./as-soon-as.component.html",
    styleUrl: "./as-soon-as.component.scss",
})
export class AsSoonAsPossibleComponent {
    form: FormGroup = this._formService.contactUs;
    dictionary: any;
    creativeTypesOptions: FormFieldOption[] = [];
    creativeStatesOptions: FormFieldOption[] = [];
    creativeAttributesOptions: FormFieldOption[] = [];
    creativeLanguajeOptions: FormFieldOption[] = [];

    private _unsubscribeAll: Subject<void> = new Subject<void>();

    constructor(
        private _formService: FormService,
        private _dialogRef: MatDialogRef<DuplicateCampaignComponent>,

        @Inject(MAT_DIALOG_DATA) public data: any,
    ) {}

    ngOnInit(): void {}

    ngOnDestroy(): void {
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }

    close() {
        this._dialogRef.close();
    }
}
